import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import('./plugins/bootstrap');
import('./plugins/maps');
import('./plugins/socket');

Vue.config.productionTip = false;
Vue.use(require('vue-moment'));


window.addEventListener('load', function () {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
});

